/** @format */

import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { signUserOut } from "./authSlice";
import { store } from "../app/store";
import { authApiSlice } from "./authApi";
import BLSpinner from "../assets/animations/BLSpinner/BLSpinner";
import { api } from "../app/services/api";

const Logout: FC = () => {
  const dispatch = useDispatch();

  const [loggedOut, setLoggedOut] = useState<boolean>(false);

  useEffect(() => {
    // Send logout request to api to invalidate cookie
    store
      .dispatch(authApiSlice.endpoints.logout.initiate(undefined))
      .then(() => {
        setLoggedOut(true);
      });

    // Remove any state stored user info
    dispatch(signUserOut());
    // TODO: maybe this could be done in user sign out action
    dispatch(
      api.util.invalidateTags([
        "Resource",
        "User",
        "Lesson",
        "SubLesson",
        "Card",
        "ResourceStatus",
      ]),
    );
  }, [dispatch]);

  // wait until logout request has completed
  return !loggedOut ? (
    <BLSpinner
      className="position-absolute top-50 start-50 translate-middle"
      size="3rem"
    />
  ) : (
    <Navigate to="/" />
  );
};

export default Logout;
